/**
 * Opens a URL in the given target window.
 *
 * This is intended to be a safe wrapper around `window.open()`:
 * - Typed options are used instead of a `windowFeatures` string.
 * - Does not return the target window, because `postMessage()` should be used to communicate with
 *   other windows.
 *
 * @param url - URL to open
 * @param [options]
 * @param [options.target='_blank'] - Name of the target window
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/open|Window.open() on MDN}
 */
export function openUrl(
  url: string,
  {
    target = '_blank',
  }: {
    target?: string;
  } = {},
) {
  setTimeout(() => {
    // eslint-disable-next-line no-restricted-syntax
    window.open(url, target);
  });
}
